import HrisSettings from './HrisSettings.page';

export default HrisSettings;
